    
    export var products = [
        {
            id:1,
            img:require("../../Images/Stethoscope1.jpg"),
            title:"Stethoscope",
            description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
            price:"350 "
        },
        {
            id:2,
            img:require("../../Images/scrup1.jpg"),
            title:"scrup",
            description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
            price:"450 "
        },
        {
            id:3,
            img:require("../../Images/Thermometer3.jpg"),
            title:"Thermometer",
            description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
            price:"240 "
        },
        {
            id:4,
            img:require("../../Images/Blood pressure cuff 1.jpg"),
            title:"Blood pressure cuff",
            description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
            price:"550 "
        },
        {
            id:5,
            img:require("../../Images/Otoscope1.webp"),
            title:"Otoscope",
            description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
            price:"780 "
        },
        {
            id:6,
            img:require("../../Images/scrup6.jpg"),
            title:"scrup",
            description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
            price:"580 "
        },
        {
            id:7,
            img:require("../../Images/Stethoscope2.jpg"),
            title:"Stethoscope",
            description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
            price:"450 "
        },
        {
            id:8,
            img:require("../../Images/scrup2.jpg"),
            title:"scrup",
            description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
            price:"500 "
        },
        {
            id:9,
            img:require("../../Images/Thermometer4.jpg"),
            title:"Thermometer",
            description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
            price:"650 "
        },
        {
            id:10,
            img:require("../../Images/Blood pressure cuff 2.jpg"),
            title:"Blood pressure cuff",
            description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
            price:"480 "
        },
        {
            id:11,
            img:require("../../Images/scrup7.jpg"),
            title:"scrup",
            description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
            price:"780 "
        },
        {
            id:12,
            img:require("../../Images/Otoscope2.jpg"),
            title:"Otoscope",
            description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
            price:"500 "
        },
        {
            id:13,
            img:require("../../Images/Blood pressure cuff6.jpg"),
            title:"Blood pressure cuff",
            description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
            price:"1000 "
        },

        {
            id:14,
            img:require("../../Images/Stethoscope3.jpg"),
            title:"Stethoscope",
            description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
            price:"250 "
        },
        {
            id:15,
            img:require("../../Images/scrup3.jpg"),
            title:"scrup",
            description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
            price:"650 "
        },
        {
            id:16,
            img:require("../../Images/Thermometer2.jpg"),
            title:"Thermometer",
            description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
            price:"3200 "
        },
        {
            id:17,
            img:require("../../Images/Blood pressure cuff 3.jpg"),
            title:"Blood pressure cuff",
            description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
            price:"555 "
        },
        {
            id:18,
            img:require("../../Images/Otoscope3.jpg"),
            title:"Otoscope",
            description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
            price:"3200"
        },
        {
            id:19,
            img:require("../../Images/Stethoscope4.jpg"),
            title:"Stethoscope",
            description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
            price:"2500"
        },
        {
            id:20,
            img:require("../../Images/scrup4.jpg"),
            title:"scrup",
            description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
            price:"700 "
        },
        {
            id:21,
            img:require("../../Images/Thermometer1.jpg"),
            title:"Thermometer",
            description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
            price:"500"
        },
        {
            id:22,
            img:require("../../Images/Blood pressure cuff 4.jpg"),
            title:"Blood pressure cuff",
            description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
            price:"1100"
        },
        {
            id:23,
            img:require("../../Images/Otoscope4.jpg"),
            title:"Otoscope",
            description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
            price:"900"
        },
        {
            id:24,
            img:require("../../Images/Stethoscope5.jpg"),
            title:"Stethoscope",
            description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
            price:"1500"
        },
        {
            id:25,
            img:require("../../Images/scrup5.jpg"),
            title:"scrup",
            description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
            price:"350"
        },
        
        {
            id:26,
            img:require("../../Images/Thermometer5.jpg"),
            title:"Thermometer",
            description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
            price:"800"
        },
        {
            id:27,
            img:require("../../Images/Blood pressure cuff 5.jpg"),
            title:"Blood pressure cuff",
            description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
            price:"490"
        },

        {
            id:28,
            img:require("../../Images/Otoscope5.jpg"),
            title:"Otoscope",
            description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
            price:"780"
        },




    
    ]
    